/* eslint-disable no-unused-vars */
import { curry } from 'lib/util'
import concatQueryParams, { getEscaped } from 'app/_shared/events/search/query/util'

/**
 * Return a search query that filters the search to only contain messages from a the current
 * request/ticket.
 *
 * @param {Gaia.AppModule.Spec} module      app module
 * @param {Gaia.Component.Spec} component   action component
 * @param {Event|object} event              information about the event that triggered this handler
 * @returns {string}
 */
const isMessage = (module, component, event) => {
  const params = {
    type: 'metatype:message',
    sourceTarget: `AND (source:(${getEscaped(module[G.MODEL][G.STATE][G.REF])}) OR target:(${getEscaped(module[G.MODEL][G.STATE][G.REF])}))`,
  }

  return concatQueryParams(params)
}

export default curry(isMessage)
